import dayjs from "dayjs";
import {FormGroup} from "reactstrap";
import {FieldWithValidation} from "../../generic/fields";
import React from "react";

const TimeField = ({name, label, state, dispatch, errors, isRequired}) => {
    const formatTime = (time) => {
        if (!time) return '';
        return dayjs(time, 'HH:mm').format('HH:mm:ss.SSS');
    };

    const handleChange = (e) => {
        const inputValue = e.target.value;
        const formattedValue = formatTime(inputValue);

        dispatch({type: 'setForm', payload: {[name]: formattedValue}});
    };

    const currentValue = formatTime(state[name] || '');

    return (
        <FormGroup>
            <FieldWithValidation
                errors={errors}
                label={label}
                name={name}
                isRequired={isRequired}
                type="time"
                value={currentValue}
                onChange={handleChange}
            />
        </FormGroup>
    );
};

export default TimeField;